
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, change, getFormValues } from 'redux-form';
import { MispariFormFields, CancelMispariWindow } from './';
import { ConfirmationWindow } from '../../lib/forms';
import { products, Auth } from '../../services';
import moment from 'moment';
import AuthService from '../../services/AuthService';

class MispariForm extends Component {
  handleKeyPress(e) {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
}
  render() {
    const { translate, handleSubmit, cancel, mispari, error, values, cancelMispari, mispariMessage, confirmationMispariMessage, phoneNumber, setStartDateFromDatePicker, setEndDateFromDatePicker } = this.props;
    let startDate
    let endDate
    if (mispari.isActiveNow) {
      startDate = null
      endDate = values.endField || values.endTimeField ? setEndDateFromDatePicker() : (values.end == 'option1' ? translate("now") : moment(mispari.forward.stoppingDate, 'YYYY/MM/DD HH:mm').format('DD/MM/YYYY HH:mm'));
    }
    else if (mispari.hasFutureMispari) {
      startDate = values.startField || values.startTimeField ? setStartDateFromDatePicker() : (values.start === "option1" ? translate("now")  :  moment(mispari.forward.startingDate, 'YYYY/MM/DD HH:mm').format('DD/MM/YYYY HH:mm'));
      endDate = values.endField || values.endTimeField ? setEndDateFromDatePicker() :  (values.end === "option1" ? translate('without-stopping') :  moment(mispari.forward.stoppingDate, 'YYYY/MM/DD HH:mm').format('DD/MM/YYYY HH:mm'));
    }
    else {
      startDate = values.start === "option2" ? setStartDateFromDatePicker() : translate("now");
      endDate = values.endField || values.endTimeField  ? setEndDateFromDatePicker() : `${translate('without-stopping')}`;
    }

    return(
      <div className="card card-service-action">
        <div className="mispari-card-block">
          <form onSubmit={handleSubmit} onKeyPress={this.handleKeyPress}>
            {error && <p className="text-danger" role="alert">{error}</p>}
            <div className="form-group row">
              <div className="form-text">
                {`${mispariMessage}`}
                <br></br>
                {mispari.forward ? ` (${translate('current-mispari-number')} ${mispari.forward.number})` : ""}
              </div>
            </div>
            <MispariFormFields phoneNumber={phoneNumber}/>
              <div className="row-btn form-line edit">
              <div className="row justify-content-end row-btn">
                <div className="col-6 col-md-3">
                  <button className="btn btn-block btn-form btn-cancel" type="button" onClick={ () => cancel() }>{translate('cancel')}</button>
                </div>
                <div className="col-6 col-md-3">
                  <button className="btn btn-block btn-form btn-submit btn-submit-save " type="button" data-target=".bd-example-modal-lg" data-toggle="modal"  >{translate('save')}</button>
                </div>
              </div>
              </div>

            <ConfirmationWindow message={confirmationMispariMessage} startDate={startDate} endDate={endDate} from={phoneNumber} to={values.forwardNumber ? values.forwardNumber ==="newNumber" ? `+${values.newNumber}` : `+${values.forwardNumber}`: mispari.forward ? `+${mispari.forward.number}` : null} />
            <CancelMispariWindow message={translate('do-you-want-cancel-Mispari')} cancelMispari={cancelMispari} />
          </form>
        </div>
      </div>
    )
  }
}
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    mispari: state.Mispari.mispari,
    mispariMessage: state.Mispari.mispariMessage,
    confirmationMispariMessage: state.Mispari.confirmationMispariMessage,
    values: getFormValues('mispari')(state) || {},
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {

  };
};

MispariForm = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(MispariForm);
MispariForm = reduxForm({
 form: 'mispari',
})(MispariForm)



class MispariFormHandler extends Component {
  constructor() {
    super();
    this.state = {
      voicemailactive: '',
      sendToMail: false,
      email: "",
    }
  }
  componentDidMount() {
  }
  cancelMispari() {
    const { setFlashMessage, translate, rest, history } = this.props;
    products.deleteMispari(rest.computedMatch.params.userProductId)
    .then((res) => {
      setFlashMessage(`${translate('mispari-canceled')}`, true);
      history.goBack();
    })
    .catch((error) => {
      setFlashMessage(error.body.errors[0].detail)
    })
    return
  }

  convertSelectedDateFromDatePicker(date) {
    return typeof date === 'string' ? date : moment(date).format('DD/MM/YYYY');
  }

  setStartDateFromDatePicker() {
    let defaultStartDateTime = this.props.mispari.forward ? moment(this.props.mispari.forward.startingDate, 'YYYY/MM/DD HH:mm') : moment();
    let startTime = this.props.values.startTimeField ? this.props.values.startTimeField : moment(defaultStartDateTime).format('HH:mm');
    let startDate = this.props.values.startField ? this.props.values.startField : moment(defaultStartDateTime, 'YYYY/MM/DD HH:mm');
    return this.convertSelectedDateFromDatePicker(startDate) + startTime;
  }

  setEndDateFromDatePicker() {
    let defaultEndDateTime = this.props.mispari.forward ? moment(this.props.mispari.forward.stoppingDate, 'YYYY/MM/DD HH:mm') : moment();
      let endTime = this.props.values.endTimeField ? this.props.values.endTimeField : moment(defaultEndDateTime, 'YYYY/MM/DD HH:mm').format('HH:mm');
      let endDate = this.props.values.endField ? this.props.values.endField : moment(defaultEndDateTime, 'YYYY/MM/DD HH:mm');
      return this.convertSelectedDateFromDatePicker(endDate) + endTime;
  }

  handleSubmit(values) {
    const { history, rest, setFlashMessage, translate, mispari, dispatch } = this.props;

    if (mispari.isActiveNow) {
      if (values.end === "option1"){
        products.deleteMispari(rest.computedMatch.params.userProductId)
          .then((res) => {
            setFlashMessage(`${translate('changes-saved-successfully')}`, true);
            history.goBack();
          })
          .catch((error) => {
            setFlashMessage(error.body.errors[0].detail)
          })
        return
      }
      const endDate = values.endField || values.endTimeField ? this.setEndDateFromDatePicker() : moment(mispari.forward.stoppingDate, 'YYYY/MM/DD HH:mm').format('DD/MM/YYYY HH:mm');
      products.updateActiveMispariEndDate(rest.computedMatch.params.userProductId, endDate)
        .then((res) => {
          setFlashMessage(`${translate('changes-saved-successfully')}`, true);
          history.goBack();
        })
        .catch((error) => {
          setFlashMessage(error.body.errors[0].detail)
        });

      return
    }
    else if (mispari.hasFutureMispari) {
      const startDate = values.startField || values.startTimeField ? this.setStartDateFromDatePicker() : (values.start === "option1" ? moment() :  moment(mispari.forward.startingDate, 'YYYY/MM/DD HH:mm'));
      const endDate = values.endField || values.endTimeField  ? this.setEndDateFromDatePicker() :  (values.end === "option1" ? null :  moment(mispari.forward.stoppingDate, 'YYYY/MM/DD HH:mm').format('DD/MM/YYYY HH:mm'));

      const end = endDate === "Invalid date" ? null : endDate
      products.updateMispari(rest.computedMatch.params.userProductId, startDate, end, mispari.forward.number)
        .then((res) => {
          if (res.body.token) {
            AuthService.setToken(res.body.token);
          }
          setFlashMessage(`${translate('changes-saved-successfully')}`, true);
          history.goBack();
        })
        .catch((error) => {
          if (error.status === 401) {
            AuthService.logOut();
          }
          setFlashMessage('err',false)
        });
      return
    }

    const startDate = values.start === "option2" ? this.setStartDateFromDatePicker() :  null;
    const endDate = values.endField ? this.setEndDateFromDatePicker() : null;
    const forwardTo = values.forwardNumber === "newNumber" ? values.newNumber : values.forwardNumber
      products.activeMispari(rest.computedMatch.params.userProductId, forwardTo, startDate, endDate )
      .then((res) => {
        setFlashMessage(`${translate('changes-saved-successfully')}`, true);
        history.goBack();
      })
      .catch((error) => {
        if (error.status === 401) {
          Auth.logOut(dispatch);
        }
        setFlashMessage(error.body.errors[0].detail)
      })
  }

   cancel(values) {
     const { history } = this.props;
     history.goBack();
   }

  render() {
    const {  rest, isActiveNow, hasFutureMispari, forwardNumber, phoneNumber} = this.props;
    return (
      <div>
        <MispariForm
          cancel={this.cancel.bind(this)}
          onSubmit={this.handleSubmit.bind(this)}
          ProductId={rest.computedMatch.params.userProductId}
          phoneNumber={phoneNumber}
          email={this.state.email}
          isActiveNow={isActiveNow}
          hasFutureMispari={hasFutureMispari}
          forwardNumber={forwardNumber}
          cancelMispari ={this.cancelMispari.bind(this)}
          setStartDateFromDatePicker={this.setStartDateFromDatePicker.bind(this)}
          setEndDateFromDatePicker={this.setEndDateFromDatePicker.bind(this)}
        />
      </div>
    );
  }
}


const MispariFormHandlerViewMapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  };
};

MispariFormHandler = connect(
  viewMapStateToProps,
  MispariFormHandlerViewMapDispatchToProps,
)(MispariFormHandler);

MispariFormHandler = withRouter(MispariFormHandler);

export default MispariFormHandler;



// WEBPACK FOOTER //
// ./src/components/Mispari/MispariForm.js